import { useCallback, useEffect, useState } from "react";
import { app } from "@microsoft/teams-js";
import * as microsoftTeams from "@microsoft/teams-js";
import { STRINGS_EN } from "../../../../constant";


const HandleDsso = ({ dssoUrl, authenticationId }) => {
  const [isValidated, setIsValidated] = useState(false);
  const domain = process.env.REACT_APP_ZYCUS_CHAT_DOMAIN;

  const queryParams = new URLSearchParams({
    dssoEnable: "true",
    deviceId: authenticationId,
  }).toString();

  const authorizeEndpoint = `${domain}?${queryParams}`;

  const initializeTeams = useCallback(async () => {
    try {
      await app.initialize();
      const context = await app.getContext();
      microsoftTeams.authentication
        .authenticate({
          url: dssoUrl,
          isExternal: false,
          width: 400,
          height: 500,
        })
        .then((result) => {
          microsoftTeams.app.notifySuccess();
        })
        .catch((reason) => {
          console.log("Login failed:", reason);
          microsoftTeams.app.notifySuccess();
          setIsValidated(true);
        });
      app.notifySuccess();
    } catch (err) {
      console.error("Error initializing Microsoft Teams SDK:", err);
      app.notifyFailure({ message: "Initialization failed" });
    }
  }, [dssoUrl]);

  useEffect(() => {
    initializeTeams();
  }, [initializeTeams]);

  if (isValidated) {
    window.location.assign(authorizeEndpoint);
    return null;
  }

  return <>{STRINGS_EN.LOADING}</>;
};

export default HandleDsso;